import { Volume2, Check, Loader2, RotateCcw } from "lucide-react";
import { speak } from "@/lib/api";
import { AcornCelebration } from "@/components/AcornCelebration";

export const SorryResult = ({ age, result, done, saving, onSaid, onRestart }) => (
  <section className={`pp-card ${done ? "gate-ok" : ""}`} data-testid="sorry-result-card">
    {done && <AcornCelebration age={age} answer={result.affirmation} golden={1} />}
    <p className="pp-label">{done ? "Apology complete" : "Your apology"}</p>
    <p className="pp-sorry-final" data-testid="sorry-final-apology">“{result.apology}”</p>
    <p className="pp-feedback" data-testid="sorry-affirmation">{result.affirmation}</p>
    {result.tip && <p className="pp-levelup" data-testid="sorry-tip"><b>A gentle idea:</b> {result.tip}</p>}
    {done ? (
      <>
        <p className="pp-reward gold" data-testid="sorry-reward"><img src="/acorn-t.png" alt="" /> +1 golden acorn for a brave apology!</p>
        <div className="pp-actions">
          <button className="pp-primary" onClick={onRestart} data-testid="sorry-restart-button"><RotateCcw className="h-5 w-5" /> Practice another</button>
        </div>
      </>
    ) : (
      <div className="pp-actions">
        <button className="pp-ghost" onClick={() => speak(result.apology)} data-testid="sorry-hear-button"><Volume2 className="h-4 w-4" /> Hear it</button>
        <button className="pp-primary" onClick={onSaid} disabled={saving} data-testid="sorry-said-button">
          {saving ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Check className="h-5 w-5" /> I said it!</>}
        </button>
      </div>
    )}
  </section>
);
